export default {"src":"/_next/static/media/features-favorites.ba292d46.gif","height":300,"width":400};